import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgFile(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.75 3C4.75 2.30964 5.30964 1.75 6 1.75H19C19.3315 1.75 19.6495 1.8817 19.8839 2.11612L26.8839 9.11612C27.1183 9.35054 27.25 9.66848 27.25 10V29C27.25 29.6904 26.6904 30.25 26 30.25H6C5.30964 30.25 4.75 29.6904 4.75 29V3ZM7.25 4.25V27.75H24.75V11.25H19C18.3096 11.25 17.75 10.6904 17.75 10V4.25H7.25ZM20.25 6.01777L22.9822 8.75H20.25V6.01777Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFile);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
